import "./service/monitoring";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { MonContexteProvider } from "./store/ContextComposant";
import { Provider } from "react-redux";
import store from "./store/store";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MonContexteProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </MonContexteProvider>
  </React.StrictMode>
);
